import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrAttractionCategory.ts
var t = () => e("attractionCategory");
//#endregion
export { t as useTrAttractionCategory };
